import { useQuery } from "@tanstack/react-query";

import { getAllPopups } from "services";

import { GET_ALL_ADMIN_POPUPS } from "consts";

import { PopupResponse } from "models";

export const useGetAllPopupsAdmin = () =>
  useQuery<PopupResponse[]>({
    queryKey: [GET_ALL_ADMIN_POPUPS],
    queryFn: ({ signal }) => getAllPopups({ signal }),
  });
